import React, { useState } from 'react';
import Cookies from 'js-cookie'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Form, InputGroup, Modal, Button } from 'react-bootstrap';
import { FormControl } from 'react-bootstrap';

function PasswordField(props) {
    const [type, setType] = useState("password");

    const toggle = (e) => {
        e.preventDefault();
        setType(type === 'text' ? 'password' : 'text');
    }

    return(
      <InputGroup className="password-toggle mb-3">
        <FormControl type={type} {...props} />
        <InputGroup.Append>
          <Button variant="light">
            <FontAwesomeIcon icon={type === "password" ? "eye" : "eye-slash"} onClick={toggle}/>
          </Button>
        </InputGroup.Append>
      </InputGroup>
    );
}

export function AudioConnectionModal(props) {

  const [webrtcAutoConnect, setWebRTCAutoConnect] = useState(Cookies.get('media.webrtc-autoconnect') === "true");

  const onWebRTCAutoConnectSwitchAction = (e) => {
    setWebRTCAutoConnect(e.target.checked);
    Cookies.set('media.webrtc-autoconnect', e.target.checked);
  };

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="text-dark"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Conexão de aúdio
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        { props.userConfig.media && props.userConfig.media.dialin && (
        <div class="card mb-3" >
          <div class="row no-gutters">
            <div class="col">
              <h5 class="card-header">Chamada telefônica</h5>
              <div class="card-body">
                <p class="card-text">
                  Disque para o número <strong>{props.userConfig.media.dialin.number}</strong> e informe a senha abaixo.
                </p>
              </div>
              <div class="card-footer">
                <div class="row no-gutters">
                  <div class="col-6 col-sm-7">
                    <form autoComplete="off">
                      <PasswordField readonly value={props.userConfig.media.dialin.password}/>
                    </form>
                  </div>
                  <div class="col-1 col-sm-1">
                  </div>
                  <div class="col-5 col-sm-4">
                    { props.mediaState === "connected" && props.mediaType === "dialin" ? (
                    <Button disabled variant="success">Conectado</Button>
                    ) : (
                    <Button href={"tel:" + props.userConfig.media.dialin.number + "," + props.userConfig.media.dialin.password}
                            variant="secondary"
                            disabled={props.mediaState !== "idle"}>
                      Discar
                    </Button>
                    )}
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        )}
        { props.userConfig.media && props.userConfig.media.webrtc && (
        <div class="card mb-3" >
          <div class="row no-gutters">
            <div class="col">
              <h5 class="card-header">Áudio no navegador</h5>
              <div class="card-body">
                <p class="card-text">Conectar usando áudio através de seu navegador.</p>
                <p class="card-text">
                  <small class="text-muted">Necessária a utilização de navegador compatível.</small>
                </p>
              </div>
              <div class="card-footer">
                <div class="row no-gutters">
                  <div class="col-6 col-sm-7">
                    <Form.Check
                      onChange={onWebRTCAutoConnectSwitchAction}
                      label="Conectar automaticamente"
                      checked={webrtcAutoConnect}
                    />
                  </div>
                  <div class="col-1 col-sm-1">
                  </div>
                  <div class="col-5 col-sm-4">
                    { props.mediaState === "connected" && props.mediaType === "webrtc" ? (
                    <Button onClick={props.disconnectWebRTC} variant="danger">Desconectar</Button>
                    ) : (
                    <Button onClick={props.connectWebRTC}
                            disabled={props.mediaState !== "idle"}
                            variant="secondary">
                      {props.mediaState === "connecting" ? "Conectando..." : "Conectar"}
                    </Button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        )}
      </Modal.Body>
      </Modal>
  );
}

export default AudioConnectionModal;
